﻿$.fn.dxCtrlDomaineDedieDns = function custom_dxCtrlDomaineDedieDns(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldomainedediedns dx-ctrl");
        this.createInstance(new cdxCtrlDomaineDedieDns(this, option));
    }
    return this;
}

window.cdxCtrlDomaineDedieDns = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var lstDns = null
    function mConstruit() {
        container.empty();
        var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()

        option.bddCtrl.mAjaxCall({
            command: "getdnsdomaineverif",
            domaine: option.domaine
        }, function (data) {

            $("<div style='font-size:120%;text-align:center;'>Pour pouvoir utiliser <b>" + option.domaine + "</b> pour vos envois d'emailing,<br/>vous devez enregistrer une configuration DNS spécifique sur celui-ci.</div>").appendTo(container)

            $("<div style='text-align:center;margin-top:10px;'>Rendez-vous chez votre hébergeur qui gère votre domaine.<br/>Modifier la zone DNS de <b>" + option.domaine + "</b> et enregistrer les 3 DNS ci-dessous.</div>").appendTo(container)
            $("<div style='text-align:center;margin-top:10px;'>Une fois cela fait, cliquez sur <b>'Verifier'</b> pour valider que vos DNS sont correctement saisie.</div>").appendTo(container)
            $("<div style='text-align:center;font-size:80%;'>(La plupart du temps, la propagation des DNS est immédiat mais cela peut parfois durer jusqu'à 48h)</div>").appendTo(container)

            lstDns = data.lstdns

            var $Table = $("<table style='width:100%;margin-top:10px;font-family:barlow condensed;'/>").appendTo(container)
            var $Tr = $("<tr style='font-weight:bold'/>").appendTo($Table)
            $("<td style='width:1px;font-size:160%padding-right:15px;'></td>").appendTo($Tr)
            var $Td = $("<td style='width:50%;'>Nom d'hôte</td>").appendTo($Tr)
            var $Td = $("<td style='width:1px;'>Type</td>").appendTo($Tr)
            var $Td = $("<td style='width:50%;'></td>").appendTo($Tr)
            var $TableBt = $("<table style='width:100%'/>").appendTo($Td)
            var $Tr = $("<tr/>").appendTo($TableBt)
            var $Td = $("<td style='width:1px;'>Contenu</td>").appendTo($Tr)
            var $Td = $("<td style='width:100%;'></td>").appendTo($Tr)
            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
            $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlButton({
                text: "Vérifier",
                onClick: function (e) {
                    lstDns = null
                    mConstruit()
                }
            })

            lstDns.forEach(function (dns, idx) {
                var $Tr = $("<tr/>").appendTo($Table)
                $("<td colspan='4'><hr/></td>").appendTo($Tr)

                var $Tr = $("<tr/>").appendTo($Table)
                if (dns.current_value == dns.data.substring(0, dns.data.length - 1)) {
                    $("<td style='width:1px;font-size:160%;color:green;padding:0 15px;'><i class='fas fa-thumbs-up'></i></td>").appendTo($Tr)
                    $Tr.css("background-color", "#e6ffe6")
                } else {
                    $("<td style='width:1px;font-size:160%;color:red;padding:0 15px;'><i class='fas fa-triangle-exclamation fa-beat'></i></td>").appendTo($Tr)
                    $Tr.css("background-color", "#ffe6e6")
                }

                var $Td = $("<td style='width:50%;'></td>").appendTo($Tr)
                $("<span/>").appendTo($Td).text(dns.name.replace("." + option.domaine + ".", ""))
                var $i = $("<i class='fas fa-copy state-hover' title='copier' style='padding-left:5px;'></i>").appendTo($Td)
                $i.on("click", function (e) {
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val(dns.name.replace("." + option.domaine + ".", "")).select();
                    document.execCommand("copy");
                    $temp.remove();
                    mNotify("Le host dns <b>" + dns.name.replace("." + option.domaine + ".", "") + "</b> a été copié dans le presse papier.", "success", 6000)
                })

                $("<br/>").appendTo($Td)

                $("<span/>").appendTo($Td).html("<span style='opacity:0.5;'>Nom complet:</span> " + dns.name.substring(0, dns.name.length - 1))
                var $i = $("<i class='fas fa-copy state-hover' title='copier' style='padding-left:5px;'></i>").appendTo($Td)
                $i.on("click", function (e) {
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val(dns.name.substring(0, dns.name.length - 1)).select();
                    document.execCommand("copy");
                    $temp.remove();
                    mNotify("Le host dns <b>" + dns.name.substring(0, dns.name.length - 1) + "</b> a été copié dans le presse papier.", "success", 6000)
                })

                $("<td style='width:1px;padding-right:5px;'></td>").appendTo($Tr).html("<div style='margin:0 2px;padding:3px;border-radius:5px;background-color:DarkSlateBlue;color:white;'>" + dns.type + "</div>")

                var $Td = $("<td style='width:50%;'></td>").appendTo($Tr)
                $("<span/>").appendTo($Td).text(dns.data.substring(0, dns.data.length - 1))
                var $i = $("<i class='fas fa-copy state-hover' title='copier' style='padding-left:5px;'></i>").appendTo($Td)
                $i.on("click", function (e) {
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val(dns.data.substring(0, dns.data.length - 1)).select();
                    document.execCommand("copy");
                    $temp.remove();
                    mNotify("Le contenu dns <b>" + dns.data.substring(0, dns.data.length - 1) + "</b> a été copié dans le presse papier.", "success", 6000)
                })

                if (dns.current_value != dns.data.substring(0, dns.data.length - 1)) {
                    $("<br/>").appendTo($Td)
                    if (dns.current_value == "") {
                        $("<span style='color:red;'>Aucun enregistrement trouvé</span>").appendTo($Td)
                    } else {
                        $("<span style='color:orange;'>Entrée actuelle: " + dns.current_value + "</span>").appendTo($Td)
                    }
                }
            })

            //var $DivBt = $("<div style='text-align:center;margin-top:30px;'></div>").appendTo(container)
            //$("<div style='display:inline-block'/>").appendTo($DivBt).dxCtrlButton({
            //    text: "Vérifier",
            //    onClick: function (e) {
            //        lstDns = null
            //        mConstruit()
            //    }
            //})

            $("<div style='font-style:italic;text-align:center;padding-top:20px;'>Pour vous aider dans la saisie de vos DNS,</div>").appendTo(container)

            if (typeof data.lien_doc == "undefined" || data.lien_doc.length == 0) {
                $("<div style='font-style:italic;text-align:center;'>vous pouvez retrouver un guide, en fonction de votre hébergeur,<br/>sur <a href='https://www.mail-tester.com/spf/' target='_blank'>https://www.mail-tester.com/spf/</a> avec différents exemples.</div>").appendTo(container)
            } else {
                $("<div style='font-style:italic;text-align:center;'>vous trouverez ci-dessous des guides pour différents hébergeurs.</div>").appendTo(container)
                $("<div style='margin:10px 30% 0 30%;'/>").appendTo(container).dxList({
                    dataSource: new DevExpress.data.DataSource({
                        store: data.lien_doc,
                        reshapeOnPush: true,
                        pageSize: 99999
                    }),
                    scrollingEnabled:false,
                    searchEnabled: true,
                    searchExpr: 'nom',
                    searchEditorOptions: {
                        label: "Chercher parmi les hébergeurs...",
                        labelMode: "floating",
                        showClearButton: true,
                    },
                    itemTemplate(data, index, element) {
                        element.css("padding", "5px")
                        element.on("click", function (e) {
                            window.open("https://www.mail-tester.com/spf/" + data.href, "_blank")
                        })
                        return $('<div>').text(data.nom);
                    },
                    //onItemClick: function (e) {
                    //    if (typeof e.itemData == 'undefined') e.itemData = data.lien_doc[e.itemIndex]
                    //    window.open("https://www.mail-tester.com/spf/" + e.itemData.href,"_blank")
                    //}
                })
            }

        }, function () {
            jauge.mHide()
        }, function () {
            mNotify("Impossible de vérifier les DNS", "error", 6000)
        })


    }

    this.isOk = function () {
        return (lstDns != null) && lstDns.filter(function (dns) { return dns.current_value != dns.data.substring(0, dns.data.length - 1) }).length == 0
    }

    this.element = function () { return container }

    mConstruit();
}